import { render, staticRenderFns } from "./ValidTagInput.vue?vue&type=template&id=51a59fa5&"
import script from "./ValidTagInput.vue?vue&type=script&lang=js&"
export * from "./ValidTagInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports